import * as React from "react";
import { useCallback, useMemo, useState } from "react";
import { FieldArray } from "formik";
import styled from "styled-components";
import { HelpBlock } from "components/bootstrap";
import SchedulingFrequencyForm from "report/report-configuration-page/SchedulingFrequencyForm";
import SchedulingFrequenciesList from "./SchedulingFrequenciesList";
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
`;
const ReportScheduling = ({ children, disabled, editAllowed }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const closeModal = useCallback(() => setShowCreateModal(false), []);
  const createScheduling = useCallback(() => setShowCreateModal(true), []);
  const args = useMemo(() => ({ createScheduling, disabled }), [createScheduling, disabled]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Header, null, children(args)), /* @__PURE__ */ React.createElement(
    FieldArray,
    {
      name: "delivery.scheduling",
      render: ({ remove, replace, push }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SchedulingFrequenciesList, { onDelete: remove, onUpdate: replace, disabled: !editAllowed }), showCreateModal && /* @__PURE__ */ React.createElement(
        SchedulingFrequencyForm,
        {
          title: "Configure new scheduling frequency",
          submitButtonText: "Add frequency",
          submitLoadingText: "Adding frequency...",
          onSubmit: (newSchedulingFrequency) => {
            closeModal();
            push(newSchedulingFrequency);
          },
          onCancel: closeModal
        }
      ))
    }
  ), /* @__PURE__ */ React.createElement(HelpBlock, null, "Configure how often this report should be sent out."));
};
export default ReportScheduling;
